<template>
    <div>
    <v-card-actions dark>
    <v-btn v-if="!filterFeed"
      color="purple accent-3"
      dark
      left
      @click="filterFeed = true">
      <v-icon>mdi-briefcase-search</v-icon>
      {{ $t('myGooday.SEARCH') }}</v-btn>
      <v-spacer></v-spacer>
      <v-btn 
      v-if="!filterFeed"
      color="purple accent-3"
      dark
      right
      to="/post">
      <v-icon>mdi-bullhorn</v-icon>
      {{ $t('myGooday.POST') }}</v-btn>
    </v-card-actions>
    <div v-if="filterFeed" class="text-center" style="color:white">
        {{ $t('myGooday.searchMenu.HEADER') }} 
    </div>
    <v-divider v-if="!filterFeed" dark class="my-4 mx-4"></v-divider>
    <v-container v-if="filterFeed">
        <div class="text-center" style="color:white">
         <v-icon dark >mdi-city</v-icon>
         {{ $t('myGooday.searchMenu.SELECTCITY') }}</div>
    <v-chip-group 
        max="1" 
        column 
        dark
        centered
        v-model="selectedCity"
        active-class="purple accent-3"
        >
        <v-chip v-for="city in cities" :key="city">
        {{ city }}
        </v-chip>
        </v-chip-group>
        <v-divider dark class="my-4 mx-4"></v-divider>
        <div class="text-center" style="color:white">
         <v-icon dark >mdi-home-group</v-icon>
         {{ $t('myGooday.searchMenu.SELECTHOOD') }}</div>
        <v-chip-group 
        max="1" 
        column 
        dark
        v-model="selectedHood"
        active-class="purple accent-3"
        >
        <v-chip v-for="hood in hoods" :key="hood">
        {{ hood }}
        </v-chip>
        </v-chip-group>
        <v-divider dark class="mx-4 my-4"></v-divider>
        <div class="text-center" style="color:white">
         <v-icon dark >mdi-toolbox</v-icon>
         {{ $t('myGooday.searchMenu.SELECTGOODAY') }}</div>
        <v-chip-group 
        max="1" 
        column 
        dark
        v-model="selectedSkill"
        active-class="purple accent-3">
        <v-chip v-for="skill in gigs" :key="skill">
        {{ skill }}
        </v-chip>
        </v-chip-group>
        <v-btn 
        :disabled="!queryOk"
        color="purple accent-3"
        dark
        block
        @click="searchGooday">
        <v-icon >mdi-briefcase-search</v-icon>
        {{ $t('myGooday.searchMenu.FINDGOODAY') }}</v-btn>
        <!-- <v-divider dark class="mx-4 my-4"></v-divider> -->
        </v-container>
        <v-col
        v-for="userad in searchFeed" :key="userad.postID" cols="12">
        <UserAd :userad="userad"/>
        </v-col>
        <v-col
        v-for="userad in userFeed" :key="userad.postID" cols="12">
        <UserAd :userad="userad"/>
        </v-col>
    </div>
</template>

<script>
import UserAd from './UserAd';
import { citiesMixin } from '../mixins/cities';
import { gigsMixin } from '../mixins/gigs';
import firebase from 'firebase/app';
import 'firebase/firestore';
export default {
    mixins : [
        citiesMixin,
        gigsMixin,
    ],
    components: {
        UserAd,
        
    },
    data() {
        return {
        //     post: {image:'',
        // description:'',
        // postedBy:'',
        // rating:'',
        // allTimeJobs:'',
        // gigType:'',
        // gigDesc:'',
        // neighborhood:'',
        // city: ''},
        filterFeed: false,
        selectedSkill: null,
        selectedHood: null,
        selectedCity: null,
        // userFeed:null,
        searchFeed: null,
        }
    },
    methods: {
        searchGooday() {
            const myCity = this.cities[this.selectedCity]
            // const myHood = this.hoods[this.selectedHood]
            const mySkill = this.gigs[this.selectedSkill]
            const myFeed = []
            // gooday collection backend reference
            var db = firebase.firestore()
            var goodayRef = db.collection('goodays')
            goodayRef.where('city', '==', myCity)
            .where('gigs','array-contains',mySkill).get()
            .then( (querySnapshot) => {
                querySnapshot.forEach( (doc) => {
                    myFeed.push(doc.data())
                })
                this.searchFeed = myFeed
                // eslint-disable-next-line no-console
                // console.log(myFeed)
                this.filterFeed = false
            })
            .catch( (error) => {
                // eslint-disable-next-line no-console
                console.log(error)
            })
        },
    },
    computed:{
        queryOk() {
            return (this.selectedCity != null  && this.selectedSkill != null) ? true : false
        },
        cities() {
            const cityList = []
            this.ethiopiaCities.forEach(element => {
                cityList.push(element.city)
            });
            return cityList
        },
        hoods() {
            const hoods = []
            const selectedCity = this.cities[this.selectedCity]
            this.ethiopiaCities.forEach(element => {
                if (element.city === selectedCity) {
                    hoods.push(...element.neighborhoods)
                } 
            })
           return hoods
        },
        // gigs() {
        //     return gigs
        // },
        userFeed() {
            return this.$store.getters['feed/getFeed']
        },
        profileCity() {
            return this.$store.getters['auth/city']
        }
    },
    mounted() {
            this.$store.dispatch('feed/refreshFeed',this.profileCity)
    }
}
</script>

<style >
.signup-form {
    max-width: 520px;
    margin: 30px auto;
    border: 1px solid #eee;
    padding: 20px;
    box-shadow: 0 2px 3px #ccc;
  }
.image-container{
  display: inline-block;
  max-width: 270px;
  }

.image-preview {
  display: block;
  max-height: 229px;
  max-width: 100%;
}
</style>